import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=476c561a&"
import script from "./BaseTooltip.vue?vue&type=script&lang=js&"
export * from "./BaseTooltip.vue?vue&type=script&lang=js&"
import style0 from "floating-vue/dist/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./BaseTooltip.vue?vue&type=style&index=1&id=476c561a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports